export class LanguageReferenceModel {
    public languageCode: string;
    public languageName: string;
    public primaryFlag: boolean;
    public sortSequence: Number;
    public statusCode: string;
}